import { render, staticRenderFns } from "./searchCer2.vue?vue&type=template&id=2864d383&scoped=true"
import script from "./searchCer2.vue?vue&type=script&lang=js"
export * from "./searchCer2.vue?vue&type=script&lang=js"
import style0 from "./searchCer2.vue?vue&type=style&index=0&id=2864d383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864d383",
  null
  
)

export default component.exports